import { AppConfigModel } from "../abstract/app-config.model";

export class PhoneAreaCode extends AppConfigModel {

    static override CLASS_NAME: string = 'PhoneAreaCode';

    readonly flag!: string;
}
